import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Variant } from "@/modules/base/enums";
import { computed } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GradientBadge',
  props: {
    limits: {
      default: () => [[Variant.SUCCESS, 66, 100], [Variant.WARNING, 33, 65], [Variant.DANGER, 0, 32]]
    },
    value: null
  },
  setup(__props) {
    const {
      limits,
      value
    } = __props;
    const type = computed(() => {
      if (!value) {
        return Variant.SUCCESS;
      }
      const range = limits.find(variantRange => value >= variantRange[1] && value <= variantRange[2]);
      if (!range) {
        return Variant.SUCCESS;
      }
      return range[0];
    });
    const classes = computed(() => {
      if (value === undefined) {
        return 'bg-slate-100 text-slate-700';
      }
      return {
        [Variant.SUCCESS]: 'bg-green-100 text-green-700',
        [Variant.WARNING]: 'bg-yellow-100 text-yellow-700',
        [Variant.DANGER]: 'bg-red-100 text-red-700'
      }[type.value];
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _mergeProps({
        class: ["py-1 inline-flex items-center justify-center font-mono w-6", _unref(classes)]
      }, _ctx.$attrs), [_renderSlot(_ctx.$slots, "default")], 16);
    };
  }
});